<template>
  <chart-container @onCSVDownload="downloadCSVPercentageParticipant(titleChart)" :titleChart="titleChart" @zoomEnabled="zoomEnabled" @zoomDisabled="zoomDisabled" :zoomGraphValue="zoomGraphValue" :downloadId="downloadId" :specificSiteId="specificSiteId" :downloadShow="dataSource && Object.keys(dataSource.data).length > 0">
    <span class="title-date" slot="header"> {{ titleDateShow }}</span>
    <fusioncharts style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" :events="fcEvents" dataEmptyMessage="No Data In" ref="overallChart" :showValues="zoomTrigger ? '1' : '0'" v-if="dataSource && Object.keys(dataSource.data).length > 0 && newSitesSelected.length > 0" slot="body" />
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import { downloadCSV, getContrast } from "@/services/visualization/data-management";
import ChartContainer from "./chart-container.vue";
import * as se from "@/services/visualization/study-executive";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    ChartContainer
  },
  props: {
    studyID: { type: String, default: "" },
    titleDate: { default: "" },
    customType: { type: String, default: "pie2d" },
    titleChart: [String],
    rawData: { default: null },
    specificSiteId: [Object, Array],
    filterTriggered: { type: Boolean, default: false },
    sitesSelected: {
      type: [Array, Object, String],
      default: function() {
        return ["all"];
      }
    },
    countrySelected: {
      type: [Array, Object, String],
      default: function() {
        return ["all"];
      }
    },
    fromDate: [Object, String],
    toDate: [Object, String],
    dataLoaded: { type: Boolean, default: false },
    zoomGraphValue: { type: String, default: "" }
  },
  watch: {
    titleDate: function(newValue) {
      this.titleDateShow = moment(newValue)
        .format("DD MMM YYYY")
        .toUpperCase();
    },
    filterTriggered: function() {
      this.series = se.generateParticipantSeries(this.rawData, this.countrySelected, this.sitesSelected);
      this.dataSource.data = this.series ? this.series : [];
      this.setChartCosmetics();
    },
    rawData: function(newValue) {
      let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
      primaryColor = primaryColor || "#00C3B3";
      if (newValue) {
        this.series = se.generateParticipantSeries(newValue, this.countrySelected, this.sitesSelected);
        this.dataSource.data = this.series ? this.series : [];
        this.dataSource.chart.labelFontColor = this.series.length === 1 ? getContrast(primaryColor) : "#959fa4";
      } else {
        this.dataSource.data = [];
      }
      this.setChartCosmetics();
    },
    zoomTrigger: function() {
      this.height = this.zoomTrigger ? "450" : "250";
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.zoomDisabled();
      }
    },
    sitesSelected: function(newValue) {
      this.newSitesSelected = newValue;
      this.setChartCosmetics();
    }
  },
  data() {
    return {
      titleDateShow: "",
      type: this.customType,
      newSitesSelected: this.sitesSelected,
      dataSource: {
        chart: {
          plottooltext: `<div id="toolTextPercentage">
                            $percentValue $label </br>
                            $value Participants
                        </div>`,
          showlegend: "1",
          showpercentvalues: "1",
          legendIconSides: "4",
          legendposition: "absolute",
          legendxposition: 850,
          legendyposition: 45,
          plotHighlightEffect: "fadeout",
          legendItemFont: "RobotoRegular",
          legendItemFontColor: "#666669",
          legendItemFontSize: "11",
          legendNumRows: 10,
          chartRightMargin: 200,
          labelBgColor: "#ffffff",
          enableSlicing: false,
          enableRotation: false,
          showLabels: 0,
          showValues: 0,
          usedataplotcolorforlabels: 0,
          pieRadius: "89%",
          theme: "fusion",
          smartLineAlpha: 0,
          labelBgAlpha: 0,
          decimals: "0",
          labelFontColor: "#959fa4"
        },
        data: []
      },
      width: "100%",
      height: "250",
      dataFormat: "json",
      downloadId: "percentage-participant-by-status",
      series: null,
      fcEvents: {
        dataPlotRollOver: evtObj => {
          setTimeout(() => {
            const el = document.getElementById("toolTextPercentage");
            const { data } = evtObj;
            const { pValue, categoryLabel, color, dataValue } = data;

            if (el) {
              let percentValue = pValue.split("%");
              percentValue = percentValue.length > 1 ? `${Math.ceil(Number(percentValue[0]))}%` : pValue;
              el.parentElement.style.padding = 0;
              el.parentElement.style.borderRadius = "4px";
              el.innerHTML = `<div id="toolTextPercentage" class="common-tooltip"
                                style="color:${getContrast(color)};background-color: ${color};font-weight: 500;">
                        ${percentValue} ${categoryLabel} </br>
                        <span style="font-family: Roboto;font-size: 10px;">${dataValue} Participants</span>
                    </div>`;
            }
          }, 10);
        }
      },
      zoomTrigger: false
    };
  },
  methods: {
    downloadCSVPercentageParticipant(title) {
      if (!_.isEmpty(this.dataSource.data)) {
        const dataForCSV = [[this.studyID]];
        let header = ["Study_id"];
        const calculate = (total, current) => {
          return total + current.value;
        };
        const totalAll = this.dataSource.data.reduce(calculate, 0);
        this.dataSource.data.map(item => {
          let percentage = Number((item.value / totalAll) * 100);
          percentage = !isNaN(percentage) ? percentage.toFixed(2) : 0;
          header = [...header, ...[item.label, `${item.label} (%)`]];
          dataForCSV[0] = [...dataForCSV[0], ...[item.value, percentage]];
        });
        downloadCSV(title, header, dataForCSV, this.specificSiteId);
      }
    },
    zoomEnabled() {
      this.$emit("zoomEnabled");
      this.zoomTrigger = true;
      this.setChartCosmetics();
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
      this.zoomTrigger = false;
      this.setChartCosmetics();
    },
    setChartCosmetics() {
      if (this.$refs.overallChart) {
        const chartRef = this.$refs.overallChart.chartObj;
        const data = chartRef.getJSONData();
        if (this.zoomTrigger) {
          data.chart.showValues = 1;
          data.chart.legendNumRows = 20;
          this.dataSource.chart.showValues = 1;
          this.dataSource.chart.legendNumRows = 20;
        } else {
          data.chart.showValues = 0;
          data.chart.legendNumRows = 10;
          this.dataSource.chart.showValues = 0;
          this.dataSource.chart.legendNumRows = 10;
        }
        chartRef.setJSONData(data);
      }
    }
  }
};
</script>
